'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { Arrow } from '@radix-ui/react-tooltip';
import { forwardRef } from 'react';
import { cn } from '../../utils/cn';
const TooltipArrow = forwardRef(({ className, ...props }, ref) => (_jsx(Arrow, { ref: ref, className: cn('h-[8px] w-3 fill-primary-500', className), ...props })));
TooltipArrow.displayName = Arrow.displayName;
export { TooltipArrow };
